let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("g6ZYs")).then(() => parcelRequire('76r0N'));